import { Link } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import Error from "components/molecules/Error";

export function useElhubStatus() {
	const { data: elhubStatus, error: elhubStatusError } = useQuery<{
		status: string;
	}>({
		queryKey: ["elhubStatus"],
		queryFn: () => getElhubStatus(),
		retry: 1,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	const elhubFetchDone = elhubStatus ?? elhubStatusError;
	const elhubDown = elhubStatus?.status !== "UP";

	return {
		elhubFetchDone,
		elhubDown,
	};
}
const getElhubStatus = async () => {
	return (await fetch("https://strombestilling-api.nte.no/elhub/health")).json();
};

export default function ElHubHealthCheckAlert() {
	const { elhubFetchDone, elhubDown } = useElhubStatus();

	if (elhubFetchDone && elhubDown) {
		return (
			<Error
				errorMessage={
					<>
						Det har oppstått en feil i kommunikasjonen med Elhub. Vennligst gå til{" "}
						<Link to="/orders/send-link">siden for å sende bestillingslenke</Link> for å fortsette. For mer informasjon, se{" "}
						<a href="https://elhub.no/driftsmeldinger">Elhubs driftsmeldinger</a>.
					</>
				}
			/>
		);
	}
	return <></>;
}
